/**
 * @file 配置
 */

const IS_PROD = process.env.NODE_ENV === 'production';

const url = IS_PROD ? 'https://stat.blibee.com' : 'http://stat.beta.wormpex.com';

const config = {
  uri: `${url}/app/log`,
};


export default config;



// WEBPACK FOOTER //
// ./src/utils/Log/config.js